/**
 * Accepts a "|" separated list of patterns
 */
$.formUtils.addValidator({
	name : 'date-multi-pattern',
	validatorFunction : function(date, $el, conf) {
		var isValid = true;
		if('' != date){
			var dateFormats = []; // used if no patterns are passed
			if($el.valAttr('format')) {
				dateFormats = $el.valAttr('format').split('|');
			} else {
				dateFormats.push('dd/mm/yyyy');
			}
			var formatValid = false;
			for(var i=0; i < dateFormats.length && !formatValid; i++){
				var v = $.formUtils.parseDate(date, dateFormats[i]) !== false;
				formatValid = $.formUtils.parseDate(date, dateFormats[i]) !== false;
			}
			isValid = formatValid;
			if(!isValid){
				var dfo = {
					dateFormats: dateFormats,
					join: function(separator){
						var x = ('"' + this.dateFormats.join('","') + '"').split(',').join(separator);
						return x;
					}
				}
				this.errorMessage = xlate('common.validation.badDateMultiPattern.msg', {patterns: dfo});
			}
		}
		return isValid;
	},
	errorMessage : '',
	errorMessageKey: ''
});
